import {
  GraphQLObjectType,
  GraphQLString,
  GraphQLList,
  GraphQLNonNull,
  GraphQLFloat
} from 'graphql';

import CardQuestionOptionType from './cardQuestionOptionType.gql';

const reviewQuestionType = new GraphQLObjectType({
  name: 'ReviewQuestionType',
  fields: () => ({
    pid: {
      type: GraphQLString,
      resolve: item => item.pid
    },
    question: {
      type: GraphQLString,
      resolve: item => item.questionText
    },
    rType: {
      type: GraphQLString,
      resolve: item => item.responseType[0]
    },
    response: {
      type: GraphQLString
    },
    responseText: {
      type: new GraphQLNonNull(GraphQLString),
      resolve: item => item.responseText || ''
    },
    maxScore: {
      type: GraphQLFloat
    },
    rating: {
      type: GraphQLFloat
    },
    options: {
      type: new GraphQLList(CardQuestionOptionType),
      resolve: item => item.options
    }
  })
});

window[reviewQuestionType.name + 'GQLType'] = reviewQuestionType;

export default reviewQuestionType;
